<p-card>
  <div class="row">
    <div class="col-12">
      <h1 class="mb-3">Gestión de Cotizaciones</h1>
      <p class="mb-3 text-color-secondary">
        Gestiona los parámetros de cotización y visualiza las cotizaciones calculadas. Crea, edita y elimina parámetros, o calcula cotizaciones en tiempo real para ver los resultados financieros detallados.
      </p>
    </div>
    <p-toast></p-toast>
  </div>

  <!-- Tabs para separar Parámetros y Cotizaciones -->
  <p-tabView>
    <!-- Tab 1: Parámetros de Cotización -->
    <p-tabPanel header="Cotizaciones de Prospección" leftIcon="fa-solid fa-sliders">
      <div class="row">
        <div class="col-12">
          <app-main-table
            [apiService]="apiQuoteParametersService"
            [columns]="quoteParametersColumns"
            [pluralEntityName]="'parámetros de cotización'"
            [additionalMainActions]="additionalMainActions"
            (onMainAction)="mainActions($event)"
            [actions]="quoteParametersActions"
            (onAction)="quoteParametersActionMethods($event)">
          </app-main-table>
        </div>
      </div>
    </p-tabPanel>

    <!-- Tab 2: Cotizaciones Calculadas (oculto para Brokers) -->
    <p-tabPanel *ngIf="role !== UserRole.BROKER" header="Cotizaciones Aceptadas" leftIcon="fa-solid fa-calculator">
      <div class="row">
        <div class="col-12">
          <app-main-table
            [apiService]="apiQuoteService"
            [columns]="quoteColumns"
            [pluralEntityName]="'cotizaciones'"
            [actions]="quoteActions"
            (onAction)="quoteActionMethods($event)">
          </app-main-table>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</p-card>

<!-- Dialog para crear/editar parámetros de cotización -->
<p-dialog 
  [(visible)]="createEntity" 
  [style]="{ width: '96vw' }" 
  [header]="action === 'CREATE' ? 'Nuevos Parámetros de Cotización' : 'Actualizar Parámetros'" 
  [modal]="true" 
  styleClass="p-fluid">

  <ng-template pTemplate="content">
    <app-quote-form></app-quote-form>
  </ng-template>

  <ng-template pTemplate="footer">
    <button 
      pButton 
      pRipple 
      label="Cancelar" 
      icon="pi pi-times" 
      class="p-button-text p-button-danger" 
      (click)="hideDialog()">
    </button>
    <button 
      pButton 
      pRipple 
      label="Guardar" 
      icon="pi pi-check" 
      class="p-button-outlined p-button-success" 
      [appHasPermission]="['quotations', 'create']" 
      (click)="saveForm()" 
      [disabled]="!quoteParametersService.entity.valid">
    </button>
    <button 
      pButton 
      pRipple 
      label="Calcular" 
      icon="fa-solid fa-calculator" 
      class="p-button-primary" 
      [loading]="loading" 
      [appHasPermission]="['quotations', 'create']" 
      (click)="getAmounts()" 
      [disabled]="!quoteParametersService.entity.valid">
    </button>
  </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="showPdfOptionsDialog"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="pdf-confirm-dialog"
    header="Opciones de PDF">
    <div class="flex align-items-center gap-3">
        <i class="pi pi-file-pdf" style="font-size: 1.5rem"></i>
        <span>¿Deseas incluir el valor residual (opción de compra) en la cotización PDF?</span>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-between w-full">
            <button pButton type="button" label="Cancelar" icon="pi pi-times"
                class="p-button-outlined p-button-danger"
                (click)="closePdfDialog()"></button>
            <div class="flex gap-2">
                <button pButton type="button" label="No, omitir" icon="pi pi-minus-circle"
                    class="p-button-outlined"
                    (click)="generatePdf(false)"></button>
                <button pButton type="button" label="Sí, incluir" icon="pi pi-check-circle"
                    class="p-button-primary"
                    (click)="generatePdf(true)"></button>
            </div>
        </div>
    </ng-template>
</p-dialog>
